import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  container: {
    width: "100%",
    background: "#ffffff",

    // softer border instead of flat white
    border: "1px solid #e5e7eb",

    borderRadius: "16px",
    padding: "18px 20px",

    // 🔥 soft layered shadow (not harsh)
    boxShadow: "0 2px 8px rgba(0,0,0,0.04)",

    // smooth interaction
    transition: "all 0.2s ease",

    "&:hover": {
      boxShadow: "0 6px 18px rgba(0,0,0,0.08)",
    },

    display: "flex",
    flexDirection: "column",
    gap: "14px",

    // 🔥 subtle background tint (key improvement)
    backgroundImage:
      "linear-gradient(to bottom, rgba(249,250,251,0.6), rgba(255,255,255,1))",
  },

  headingContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",

    // 🔥 visual separation
    borderBottom: "1px solid #f1f5f9",
    paddingBottom: "8px",

    "& > h3": {
      fontSize: "16px",
      fontWeight: 700,
      color: "#111827",
      margin: 0,
      lineHeight: 1.3,
    },

    "& > p": {
      fontSize: "12px",
      color: "#6b7280",
      margin: 0,
    },
  },

  content: {
    width: "100%",
    flex: 1,
  },

  // 🔥 Tablet
  "@media (max-width: 768px)": {
    container: {
      padding: "14px",
      borderRadius: "14px",
    },
  },

  // 🔥 Mobile
  "@media (max-width: 480px)": {
    container: {
      padding: "12px",
      borderRadius: "12px",
      margin: "8px 0",
    },

    headingContainer: {
      "& > h3": {
        fontSize: "14px",
      },
      "& > p": {
        fontSize: "11px",
      },
    },
  },
}));

export default useStyles;